module.exports = __webpack_public_path__ + "static/media/carousel2.42898993.jpeg";